import { Component, OnInit } from '@angular/core';
import { Empresa } from '../../core/models/empresa';
import { EmpresaService } from '../../core/services/empresa.service';
import { AuthService } from '../../core/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-empresa',
  templateUrl: './empresa.component.html',
  styleUrls: ['./empresa.component.scss'],
})
export class EmpresaComponent implements OnInit {
  empresa: Empresa | null = null;
  loading = false;
  errorMessage: string | null = null;
  needRelogin = false;

  constructor(
    private readonly empresaService: EmpresaService,
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.loadEmpresa();
  }

  private loadEmpresa(): void {
    let empresaId = this.authService.getEmpresaId();
    console.log('[Empresa] empresaId from token/storage:', empresaId);

    if (!empresaId) {
      this.errorMessage = 'Tenant não configurado. Faça login novamente para selecionar a empresa.';
      this.needRelogin = true;
      console.warn('[Empresa] empresaId ausente; solicitando re-login');
      return;
    }

    this.needRelogin = false;
    this.loading = true;
    this.errorMessage = null;
    this.empresaService.obterPorTenant(empresaId).subscribe({
      next: (res) => {
        this.empresa = res;
        this.loading = false;
      },
      error: (err) => {
        console.error('Erro ao carregar empresa:', err);
        if (err?.status === 401) {
          this.errorMessage = 'A requisição não foi autorizada. Verifique a configuração do tenant e do servidor.';
        } else if (err?.status === 404) {
          this.errorMessage = 'Empresa não encontrada para o tenant atual.';
        } else {
          this.errorMessage = 'Não foi possível carregar os dados da empresa.';
        }
        this.loading = false;
      },
    });
  }

calcularMesesEDiasRestantes(empresa: Empresa): { meses: number; dias: number } {
  if (!empresa?.dataVencimento) {
    return { meses: 0, dias: 0 };
  }

  const hoje = new Date();
  const vencimento = new Date(empresa.dataVencimento);

  let anos = vencimento.getFullYear() - hoje.getFullYear();
  let meses = vencimento.getMonth() - hoje.getMonth() + (anos * 12);
  let dias = vencimento.getDate() - hoje.getDate();

  // Se dias negativos, ajusta mês
  if (dias < 0) {
    meses--;
    const ultimoDiaMesAnterior = new Date(
      vencimento.getFullYear(),
      vencimento.getMonth(),
      0
    ).getDate();
    dias += ultimoDiaMesAnterior;
  }

  if (meses < 0) {
    return { meses: 0, dias: 0 };
  }

  return { meses, dias };
}

formatarMesesEDias(empresa: Empresa): string {
  const { meses, dias } = this.calcularMesesEDiasRestantes(empresa);
  return `${meses} meses e ${dias} dias`;
}

  relogin(): void {
    // Opção: limpar tenant e redirecionar para login para reconfigurar
    this.authService.clearTenant();
    // opcional: também limpar token para forçar login
    // this.authService.logout();
    this.router.navigate(['/login']);
  }
}
